import React from 'react';

export default function useWillUnmount(willUnmount: () => void = () => null) {
	React.useEffect(() => willUnmount, []);
}
